export interface InAppPromoCodeAvailability {
    available: boolean;
    apple_available: boolean;
    google_available: boolean;
    apple_missing: string[];
    google_missing: string[];
}

export const emptyInAppPromoCodeAvailability = (): InAppPromoCodeAvailability => ({
    available: false,
    apple_available: false,
    google_available: false,
    apple_missing: [],
    google_missing: [],
});
